export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fd7e6e1bbd4cb6c61512aea55155075feba8a0440&name=fetchTypeahead!'